export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 110,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'containerName',
    align: 'center',
    width: 150,
    title: that.$l('form_label_containerName') || '箱型名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'containerDesc',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('form_label_containerDesc') || '箱型说明',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'containerLength',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('form_label_containerLength') || '内径长（米）',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'containerWidth',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('form_label_containerWidth') || '内径宽（米）',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'containerHeight',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('form_label_containerHeight') || '内径高（米）',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'containerVolume',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('form_label_containerVolume') || '内径体积（立方米）',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'loadVolume',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('form_label_loadVolume') || '装载体积（立方米）',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'loadWeight',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('form_label_loadWeight') || '装载重量（公斤）',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'containerStatus',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: that.$l('INDEX.table_label_State') || '有效状态',
    slots: {default: 'status'},
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createDate',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyDate',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
